import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { scroller, animateScroll } from 'react-scroll';

import { useMenuContext, useLoadingContext } from '@hooks';
import { HeaderLayout } from '@layouts';

import MainMenuChips from './components/MainMenuChips';
import SubMenuChips from './components/SubMenuChips';
import ProductsList from './components/ProductsList';
import BottomRecommendBanner from './components/BottomRecommendBanner';

import { useStyles } from './styles';
import ProductCard from '../../components/ProductCard';

export default function MenuScreen() {
  const classes = useStyles();
  const history = useHistory();
  const topBannerRef = useRef();

  const [sectionMenu, setSectionMenu] = useState([]);
  const [promotedProduct, setPromotedProducts] = useState([]);
  const [isDisplayBottomBanner, setDisplayBottomBanner] = useState(false);
  const [subMenuCoordsList, setSubMenuCoordsList] = useState([]);
  const [bottomBannerText, setBottomBannerText] = useState('');
  const [tabValue, setTabValue] = useState({
    id: '',
    index: 0,
    items: 'Cocktails',
  });
  const [sectionTabValue, setSectionTabValue] = useState({ id: '', index: 0 });
  const { setIsLoading } = useLoadingContext();

  const {
    fetchedMenu,
    fetchedStructure,
    fetchMenuSectionsList,
  } = useMenuContext();

  let defaultMenu = fetchedStructure.filter(item => item.type === 'DEFAULT');
  defaultMenu.sort((a, b) => a.sort - b.sort);

  let submenuList = fetchedStructure.filter(
    item => item.type === 'SUBMENU' && item.parent === tabValue.id,
  );
  submenuList.sort((a, b) => a.sort - b.sort);

  const defaultRecommendProduct = fetchedStructure.find(
    section =>
      section.type === 'DEFAULT' &&
      section.recommendationBanner &&
      section.id === tabValue.id,
  );
  const subMenuRecommendProduct = fetchedStructure.find(
    section =>
      section.type === 'SUBMENU' &&
      section.recommendationBanner &&
      section.parent === tabValue.id,
  );

  const getMenuData = async () => {
    if (fetchedMenu?.length === 0 || fetchedStructure?.length === 0) {
      setIsLoading(true);
      const response = await fetchMenuSectionsList();
      setIsLoading(false);

      if (!response) {
        history.push('/');
      }
    }
  };

  useEffect(() => {
    getMenuData();
    extractMenu();
  }, []); // eslint-disable-line

  const extractMenu = () => {
    if (fetchedStructure.length > 0 && fetchedMenu.length > 0) {
      const promotedProduct = fetchedMenu.filter(item => item.promotedProduct);
      setPromotedProducts(promotedProduct);

      const defaultMenu = fetchedStructure.filter(
        item => item.type === 'DEFAULT',
      );
      defaultMenu.sort((a, b) => a.sort - b.sort);

      const submenuList = fetchedStructure.filter(
        item => item.type === 'SUBMENU',
      );
      submenuList.sort((a, b) => a.sort - b.sort);

      if (tabValue.id === '') {
        setTabValue({
          id: defaultMenu[0].id,
          index: 0,
          items: defaultMenu[0].recommendationBanner,
        });
        setSectionTabValue({ id: submenuList[0].id, index: 0 });
      }
      const sectionMenu = [];

      const recommendedProductName = fetchedStructure.find(
        section => section.type === 'DEFAULT' && section.recommendationBanner,
      );
      fetchedStructure.find(
        section =>
          section.type === 'SUBMENU' &&
          section.recommendationBanner &&
          section.parent === tabValue.id,
      );

      fetchedStructure.filter(item => item.recommendationBanner && item);

      if (recommendedProductName) {
        setBottomBannerText(recommendedProductName.name);
      }

      setSectionMenu(sectionMenu);
    }
  };

  useEffect(extractMenu, [fetchedStructure, fetchedMenu]);

  const onChipTab = activeMenu => {
    setTabValue(activeMenu);
    setSectionTabValue({ id: '', index: 0 });
    extractMenu(activeMenu.index);

    animateScroll.scrollToTop({
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -160,
    });
  };

  const goToLocation = (subsection, index) => {
    setSectionTabValue({ id: subsection.id, index });
    scroller.scrollTo(subsection.name, {
      duration: 500,
      delay: 100,
      smooth: true,
      offset: -160,
    });
  };

  const handleDisplayingTopBanner = () => {
    if (window.scrollY >= topBannerRef.current.getBoundingClientRect().top) {
      setDisplayBottomBanner(true);
      return;
    }
    setDisplayBottomBanner(false);
  };

  const handleDisplayingBottomBanner = () => {
    const isSubMenuBrowsing = subMenuCoordsList.find(
      item => window.scrollY >= item.start && window.scrollY <= item.end,
    );

    if (isSubMenuBrowsing) {
      const foundSectionMenuItem = sectionMenu.find(
        sectionMenuItem => sectionMenuItem.id === isSubMenuBrowsing.id,
      );

      setBottomBannerText(foundSectionMenuItem.recommendationBanner);
      setDisplayBottomBanner(true);
      return;
    }

    setBottomBannerText('');
    setDisplayBottomBanner(false);
  };

  const handleDisplayingBanners = () => {
    if (subMenuCoordsList.length > 0 && !topBannerRef?.current) {
      handleDisplayingBottomBanner();
    }

    if (topBannerRef?.current) {
      handleDisplayingTopBanner();
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleDisplayingBanners);
    return () => window.removeEventListener('scroll', handleDisplayingBanners);
    // eslint-disable-next-line
  }, [subMenuCoordsList]);
  const randomPromotedProduct =
    promotedProduct.length > 0 &&
    promotedProduct[Math.floor(Math.random() * 4)];
  const sessionString = localStorage.getItem('session');
  const sessionParsed = JSON.parse(sessionString);

  return (
    <HeaderLayout>
      <div style={{ marginTop: '110px' }}>
        <div className={classes.TopScrollBar}>
          <div className={classes.TopScrollBarInner}>
            <MainMenuChips
              tabValue={tabValue}
              fetchedStructure={defaultMenu}
              onChipTab={onChipTab}
            />
            <SubMenuChips
              sectionTabValue={sectionTabValue}
              fetchedStructure={submenuList}
              tabValue={sectionTabValue}
              goToLocation={goToLocation}
            />
          </div>
        </div>

        {tabValue.items === 'cocktail' &&
          randomPromotedProduct &&
          sessionParsed.visit.promoteProductsTestGroup === 'a' && (
            <div
              style={{
                position: 'relative',
                display: 'block',
                margin: '8rem 1rem 0rem 1rem',
              }}
            >
              <ProductCard product={randomPromotedProduct} promoted />
            </div>
          )}
        {tabValue.items === 'Cocktails' &&
          sessionParsed.visit.promoteProductsTestGroup === 'a' &&
          randomPromotedProduct && (
            <div
              style={{
                position: 'relative',
                display: 'block',
                margin: '8rem 1rem 0rem 1rem',
              }}
            >
              <ProductCard product={randomPromotedProduct} promoted />
            </div>
          )}

        {submenuList.map(submenu => {
          const filteredMenu = fetchedMenu.filter(
            item => item.menuSection === submenu.id,
          );
          filteredMenu.sort((a, b) => a.sort - b.sort);

          return (
            <ProductsList
              key={submenu.name}
              sectionMenu={filteredMenu}
              name={submenu.name}
              topBannerRef={topBannerRef}
              defaultRecommendProduct={defaultRecommendProduct}
              subMenuRecommendProduct={subMenuRecommendProduct}
              setSubMenuCoordsList={setSubMenuCoordsList}
            />
          );
        })}
        <BottomRecommendBanner
          isDisplayBottomBanner={isDisplayBottomBanner}
          bottomBannerText={bottomBannerText}
        />
      </div>
    </HeaderLayout>
  );
}
